/**
 * We would be getting multiple content mime type back from OMM
 * we need to only consider application/xml at catalog level
 */
export const CONTENT_MIME_TYPE = 'application/xml';

export const SECTIONS_TAGS =  ['-sect', '-group'];
export const TITLE_TAGS =  ['title', 'ietitle'];

/**
 * We would be getting multiple content name back from OMM
 * we need to only consider OMMComplete at catalog level
 */
export const CONTENT_NAME = 'OMMComplete';

export const OMM_NODES = {
    PARA : 'para',
    TITLE:'title',
    WARNING:'warning',
    DANGER:'danger',
    CAUTION:'caution',
    NOTICE:'notice',
    NOTE:'note',
    DEFLIST:'deflist',
    RANDLIST:'randlist',
    STEPLIST: 'steplist',
    SPECLIST: 'speclist',
    SPECS:'specs',
    REFER:'refer',
    PICTOPARA:'picto-para',
    FIGURE:'figure',
    TABLE: 'table',
    STEP: 'step',
    SECT: 'sect',
    ADDR: 'address'
}